module.exports = __webpack_public_path__ + "static/media/backspace-sound.94c3bf28.mp3";